module.exports = __webpack_public_path__ + "img/driver-management.77a922da.svg";